module.exports = __webpack_public_path__ + "47d34c8af0ed825f32970a23a60802e6.png";